module.exports = __webpack_public_path__ + "static/media/character-04.cad014d6.png";